<template>
  <shared-step-editor-modal
    :open="open"
    :width="490"
    title="Send Test Email"
    closeText="Close"
    confirmText="Confirm"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <div class="modal-send-email__subheader">
      Send test email to yourself (or to somebody else) to see what exactly your contacts receive.
    </div>
    <shared-modal-input-group
      v-for="field in inputs"
      :key="field.name"
      :name="field.title"
      v-model="field.value"
      class="modal-send-email__inputs"
    />
    <span v-if="error" class="modal-send-email__error">All fields are required!</span>
  </shared-step-editor-modal>
</template>

<script>
import SharedStepEditorModal from '../../shared/SharedStepEditorModal';
import SharedModalInputGroup from '../../shared/modal/SharedModalInputGroup';
export default {
  components: {SharedStepEditorModal, SharedModalInputGroup},
  props: {
    open: Boolean,
    user: Object,
  },
  data: () => ({
    inputs: [
      {name: 'firstName', title: 'First Name', value: ''},
      {name: 'lastName', title: 'Last Name', value: ''},
      {name: 'email', title: 'Email Address', value: ''},
    ],
    error: false,
  }),
  created() {
    this.inputs = this.inputs.map(input => {
      return {...input, value: this.user[input.name]};
    });
  },
  methods: {
    handleConfirm() {
      const newFields = {};
      this.inputs.forEach(field => {
        newFields[field.name] = field.value;
      });
      if (this.inputs.some(field => !field.value)) {
        this.error = true;
        return;
      }
      this.$emit('confirm', newFields);
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.modal-send-email {
  &__subheader {
    text-align: left;
    margin-bottom: 10px;
    color: #43454b;
  }
  &__inputs {
    color: black;
  }
  &__error {
    color: red;
  }
}
</style>
